import { theme } from '@factorialco/deprecated-design-system'
import { OneOnOneMeetingFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { CalendarEventNormalizer } from 'modules/core/components/CalendarEventList/types'
import { stringToDate } from 'modules/core/lib/dates'

export const oneOnOneMeetingNormalizer: CalendarEventNormalizer<OneOnOneMeetingFragment> = ({
  node: item,
}: OneOnOneMeetingFragment) => {
  const startOn = stringToDate(item.startTime, 'backend_datetime')

  const title = `1:1 ${item?.oneOnOne?.firstParticipant?.access.firstName} & ${item.oneOnOne?.secondParticipant?.access?.firstName}`

  const description = item?.startTime ? moment(item.startTime).format('DD/MM') : ''

  const color = theme.colors.grey800

  return {
    title,
    color,
    description,
    toDate: startOn.toDate(),
    isPending: false,
  }
}
